import * as React from "react"
import { cn } from "@/shared/ui/utils/tailwind"

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

/**
 * Styled text input primitive.
 *
 * @param {InputProps} props - Input properties.
 * @returns {JSX.Element} Rendered input.
 */
const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-(--radius-md) border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
